import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { TerminalProfileEntity } from "src/app/features/TerminalProfile/types/TerminalProfileEntity";
import { SelectDynamic, TextInput } from "../../../../../components/Form/formComponents";
import { NumberInput } from "../../../../../components/Form/formComponents/Number/NumberInput";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import {
    statusSelectorConfig,
    terminalTemplateSelectConfig,
    terminalTypeSelectConfig,
} from "../../../../../components/SearchForm/FormSearchUtils";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const TerminalProfilesSearchForm: FC<SearchFormProps<TerminalProfileEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("form.system.id")} name="id">
                <NumberInput name="id" readOnly={false} />
            </Form.Item>
            <Form.Item label={t("terminalProfilesSearchForm.terminalType")} name="terminalType">
                <SelectDynamic
                    name="terminalType"
                    label={t("terminalProfilesSearchForm.terminalType")}
                    fieldConfig={terminalTypeSelectConfig}
                />
            </Form.Item>
            <Form.Item label={t("form.name")} name="name">
                <TextInput name="name" />
            </Form.Item>
            <Form.Item label={t("terminalProfile.terminalTemplate")} name="terminalTemplate">
                <SelectDynamic
                    name="terminalTemplate"
                    label={t("terminalProfile.terminalTemplate")}
                    fieldConfig={terminalTemplateSelectConfig}
                />
            </Form.Item>
            <Form.Item label={t("form.status")} name="status">
                <SelectDynamic name="status" label={t("form.status")} fieldConfig={statusSelectorConfig} />
            </Form.Item>
        </SearchForm>
    );
};
